module.exports = __webpack_public_path__ + "img/gem-found-blue.572e3edd.png";